import React, { useContext, useEffect } from "react";
import { CheckoutContext } from "../../context/CheckoutContext";
import PaqueteFeatures from "../paquetes/PaqueteFeatures";
import { formatMonto, S3_ENDPOINT } from "../../utils";
import { features, featuresOnline } from "../../utils/paquetes";
import parse from "html-react-parser";

const CheckoutClassPackage = ({ class_package_id }) => {
  const { descuento, class_package, getPaquete } = useContext(CheckoutContext);

  const onSale = () =>
    class_package !== null
      ? class_package.sale_price && class_package.sale_price !== null
      : false;

  useEffect(() => {
    getPaquete(class_package_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [class_package_id]);

  const renderResultadoDescuento = () => {
    if (descuento && descuento !== null) {
      let total = class_package.price;
      if (descuento.type !== "class_amount") {
        if (descuento.is_percent) {
          let porcentaje = parseFloat(1 - descuento.amount / 100);
          total = parseFloat(class_package.price) * porcentaje;
        } else {
          total = class_package.price - descuento.amount;
        }
        total = parseFloat(total).toFixed(2);
        return (
          <div className="container-fluid px-0">
            <h5>
              Total con Descuento: {"$"}
              {total} MXN {renderDiscountPeriod()}
            </h5>
          </div>
        );
      }
      return (
        <div className="container-fluid px-0">
          <h5>Recibe {descuento.amount} clases presenciales de regalo</h5>
        </div>
      );
    }
  };

  const renderDiscountPeriod = () => {
    if (descuento && descuento !== null) {
      if (descuento.first_invoice_only) {
        return `tu primer pago. Después $${formatMonto(
          class_package.price,
        )} MXN ${renderPeriod()}`;
      }
    }
  };

  const renderPeriod = () => {
    if (class_package.is_subscription) {
      return `cada ${
        class_package.subscription_interval === 1
          ? ""
          : class_package.subscription_interval
      }${
        class_package.subscription_period === "month"
          ? class_package.subscription_interval === 1
            ? "mes"
            : " meses"
          : class_package.subscription_period === "day"
            ? " días"
            : class_package.subscription_interval === 1
              ? "año"
              : " años"
      }`;
    }
  };

  const renderImage = () => {
    const thumbnail = class_package.thumbnail_file;
    if (thumbnail) {
      return (
        <img
          src={
            thumbnail.src
              ? thumbnail.src
              : `${S3_ENDPOINT}/${thumbnail.name}.${thumbnail.type}`
          }
          style={{ objectFit: "contain" }}
          className="class_package-img mb-3 w-100 h-auto "
          alt="package thumbnail"
        />
      );
    }
  };

  const renderDescription = () => {
    const htmlRegex = /<([a-z]+)\s*\/?[^>]*>/i;
    const isHTML = htmlRegex.test(class_package.description);

    if (isHTML) {
      return parse(class_package.description);
    }
    return <p>{class_package.description}</p>;
  };

  const renderPresenciales = () => {
    if (class_package.class_amount !== null && class_package.class_amount > 0) {
      return (
        <div className="mt-3">
          <p className="mb-1">
            Acceso a <b>{class_package.class_amount}</b> clases presenciales con
            vigencia de <b>{class_package.expiration_days}</b> días
          </p>
          {class_package.include_online && (
            <p className="mb-1">
              Acceso a TBM Online ilimitado (clases en línea)
            </p>
          )}
        </div>
      );
    }
  };

  const renderClassPackage = () => {
    if (class_package && class_package !== null) {
      const price =
        class_package.sale_price !== null && class_package.sale_price !== ""
          ? class_package.sale_price
          : class_package.price;
      return (
        <div>
          {renderImage()}
          <h3>{class_package.title}</h3>
          {renderPresenciales()}
          {class_package.short_description !== null && (
            <p>{class_package.short_description}</p>
          )}
          {renderDescription()}
          {class_package.class_amount > 0 && (
            <ul style={{ listStyleType: "none" }} className="ps-0 ms-0 mb-0">
              <li>
                <i className="fa fa-check me-1 text-primary" />
                {class_package.class_amount} clases presenciales en The Body
                Method
              </li>
              <li>
                <i className="fa fa-check me-1 text-primary" />
                Vigencia de {class_package.expiration_days} días
              </li>
              <li>
                <i className="fa fa-check me-1 text-primary" />
                Reserva tus clases desde la plataforma
              </li>
            </ul>
          )}
          {class_package.free_trial_length > 0 && (
              <ul style={{ listStyleType: "none" }} className="ps-0 ms-0 mb-0">
                <li>
                  <i className="fa fa-check me-1 text-primary" />
                  {class_package.free_trial_length} días gratis
                </li>
              </ul>
            )}
          {class_package.include_online && class_package.class_amount > 0 && (
            <PaqueteFeatures features={features} />
          )}
          {class_package.include_online &&
            class_package.class_amount === null && (
              <PaqueteFeatures features={featuresOnline} />
            )}
          <h5>
            Total:{" "}
            {class_package.free_trial_length > 0 && (
              <>
                <span className="text-primary">$0 MXN</span>
                <br />
                <span>Después de {class_package.free_trial_length} días, </span>
              </>
            )}
            {onSale() && (
              <span className="strike-through d-inline-block mx-1 text-danger">
                {"$"}
                {formatMonto(class_package.price)}
              </span>
            )}
            {"$"}
            {formatMonto(onSale() ? class_package.sale_price : price)}
            {" MXN "}
            {renderPeriod()}
          </h5>
          {renderResultadoDescuento()}
          {class_package.subscription_period !== null && (
            <ul className="ps-3">
              <li className="small">No hay ningún cargo por cancelación.</li>
              <li className="small">
                El cargo se realizará automáticamente a tu forma de pago.
              </li>
              <li className="small">Puedes cancelar cuando quieras.</li>
            </ul>
          )}
        </div>
      );
    }
  };

  return (
    <div>
      <h3>Estás Comprando</h3>
      <div className="mb-3 card no-scale">{renderClassPackage()}</div>
    </div>
  );
};

export default CheckoutClassPackage;
